import tippy from "tippy.js";

// @ts-expect-error
tippy("[data-tippy-content]");
